import React, { useState } from 'react'
import _cx from 'classnames/bind'
import type { Maybe, OnlineAuctionSegmentBid } from '@adc/sdk/types'
import { Icon, Text } from '@adc/ui-adc'
import { useListingContext } from 'common/context/listing'
import { BiddingHistoryModal } from './modal'
import cls from './styles.scss'

// TODO: change this whole file to typescript

const cx = _cx.bind(cls)

export const TRIGGER_TEXT = 'Bid History'
const defaultTrigger = (
  <div className={cx('bid-history-cta', 'u-pointer-cursor')} tabIndex={0}>
    <Icon color='info' name='history' size='large' fitted />
    <Text color='info' size='small' className='u-ml-1'>
      {TRIGGER_TEXT}
    </Text>
  </div>
)

interface BidHistoryProps {
  trigger?: React.ReactElement
}

const BidHistory = ({ trigger = defaultTrigger }: BidHistoryProps) => {
  const { segment, listing } = useListingContext()

  const [isHistoryOpen, setIsHistoryOpen] = useState(false)
  interface BiddingHistoryItem {
    bid: Maybe<OnlineAuctionSegmentBid>
    bidHistoryDescription: string
    bidHistoryUnresolved: string
    number: number
  }

  const [biddingHistory, setBiddingHistory] = useState<BiddingHistoryItem[]>([])

  const showBiddingHistory = () => {
    segment.__methods__
      .getSummarizedBidHistory()
      .then(resp => {
        setIsHistoryOpen(true)
        setBiddingHistory(resp)
      })
      .catch((error: unknown) => {
        console.warn('Error fetching bidding history:', error)
      })
  }

  const hideBiddingHistory = () => {
    setIsHistoryOpen(false)
  }

  const clonedTrigger = React.cloneElement(trigger, {
    'data-elm-id': 'bid_history_target',
    onClick: showBiddingHistory,
  })

  return (
    <>
      {clonedTrigger}
      <BiddingHistoryModal
        biddingHistory={biddingHistory}
        listing={listing}
        onClose={hideBiddingHistory}
        open={isHistoryOpen}
      />
    </>
  )
}

export default BidHistory
